'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _UndefinedContent = require('./UndefinedContent');

var _UndefinedContent2 = _interopRequireDefault(_UndefinedContent);

var _logging = require('../lib/logging');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Geosuggest = void 0;

var LocationInput = function (_Component) {
  _inherits(LocationInput, _Component);

  function LocationInput(props) {
    _classCallCheck(this, LocationInput);

    // Import only if instantiated
    var _this = _possibleConstructorReturn(this, (LocationInput.__proto__ || Object.getPrototypeOf(LocationInput)).call(this, props));

    Geosuggest = require('react-geosuggest').default;

    _this.state = { fields: {} };
    return _this;
  }

  _createClass(LocationInput, [{
    key: 'onSelect',
    value: function onSelect(address_components, location) {
      var _this2 = this;

      var fields = address_components.reduce(function (acc, c) {
        return _extends({}, acc, _defineProperty({}, c.types[0], c.long_name));
      }, _extends({}, location));

      if (!fields.locality) {
        fields.locality = fields.administrative_area_level_3;
      }

      if (!fields.street_number) {
        // if is required, do not use default value
        var streetNumberItem = _lodash2.default.find(this.props.items, { locationField: 'street_number' });
        var isRequired = streetNumberItem && streetNumberItem.isRequired;
        fields.street_number = !isRequired ? 'n/d' : fields.street_number;
      }

      //log('Address components', address_components);
      //log('Fields', fields);

      ['route', 'street_number', 'postal_code', 'locality', 'country', 'lat', 'lng'].forEach(function (locationField) {

        if (!fields[locationField]) {
          fields[locationField] = '';
        }

        var item = _lodash2.default.find(_this2.props.items, { locationField: locationField });

        if (item) {
          _this2.props.onChange(_defineProperty({}, item.name, fields[locationField]));
        }
      });

      this.setState({ fields: fields });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var customClassNames = this.props.customClassNames || [];

      //console.log('Fields', this.state.fields);

      var addressFields = this.props.items.filter(function (item) {
        return ['lat', 'lng'].indexOf(item.locationField) < 0;
      });

      var fieldsHidden = !this.state.fields.route && !(_lodash2.default.find(addressFields, { locationField: 'route' }) || {}).initialValue;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('field', { hidden: this.props.hidden }) },
        _react2.default.createElement(
          'div',
          { className: _classnames2.default.apply(undefined, ['field', 'longInputs'].concat(_toConsumableArray(customClassNames))) },
          _react2.default.createElement(
            'label',
            null,
            this.props.label
          ),
          _react2.default.createElement(
            'div',
            { className: 'ui input inputItem textInputItem' },
            _react2.default.createElement(Geosuggest, {
              placeholder: 'Ricerca...',
              types: this.props.suggestionTypes,
              initialValue: this.props.initialValue,
              onSuggestSelect: function onSuggestSelect(_ref) {
                var gmaps = _ref.gmaps,
                    location = _ref.location;

                if (!gmaps) {
                  (0, _logging.warn)('onSuggestSelect: gmaps is null');
                  return;
                }

                var address_components = gmaps.address_components;


                _this3.onSelect(address_components, location);
              }
            })
          ),
          this.props.errors && this.props.errors.length > 0 && _react2.default.createElement(
            'label',
            { className: 'ui red basic label' },
            this.props.errors.map(function (error, key) {
              return _react2.default.createElement(
                'div',
                { key: key },
                error
              );
            })
          )
        ),
        addressFields.map(function (item, key) {
          return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('field', 'longInputs', 'locationInputItem', { hidden: fieldsHidden }), key: key },
            _react2.default.createElement(
              'label',
              null,
              item.label,
              ': '
            ),
            _react2.default.createElement(
              'span',
              { className: (0, _classnames2.default)('ui', 'input', 'inputItem', 'textInputItem', item.locationField) },
              (typeof _this3.state.fields[item.locationField] === 'string' ? _this3.state.fields[item.locationField] : item.initialValue) || _react2.default.createElement(_UndefinedContent2.default, null)
            )
          );
        })
      );
    }
  }]);

  return LocationInput;
}(_react.Component);

LocationInput.propTypes = {
  label: _propTypes2.default.string,
  items: _propTypes2.default.arrayOf(_propTypes2.default.object),
  initialValue: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  errors: _propTypes2.default.array,
  country: _propTypes2.default.string,
  suggestionTypes: _propTypes2.default.arrayOf(_propTypes2.default.string),
  customClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
  hidden: _propTypes2.default.bool
};

exports.default = LocationInput;


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/components/LocationInput.js
// module id = 162
// module chunks = 0